/**
 * 도급사업관리 기본정보(SUB_BASIC_01) 컬럼 정의
 * SUB_BASIC_01 화면 전용 컬럼 정의
 */

import CreateColumn from '../../../../Services/agGrid/createColumn';

/**
 * 도급사업관리 기본정보 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // NO 컬럼 (체크박스 포함)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      maxWidth: 80,
      checkboxProps: {
        DeleteNewRow1: props.DeleteNewRow1,
        RestoreRow1: props.RestoreRow1,
        gridRef1: props.gridRef1,
        rowData1: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef,
        lastCheckedIndexRef: props.lastCheckedIndexRef,
        handleRowSelection: props.handleRowSelection,
      },
    }),
    // 도급업체코드 컬럼 (숨김)
    CreateColumn(
      'custCd',
      '도급업체코드',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        maxWidth: 100,
      }
    ),
    // 업체명 컬럼
    CreateColumn('custNm', '업체명', 'left', 300, true, true, false, 'text', {
      minWidth: 100,
      maxLength: 100,
    }),
    // 상주 여부 컬럼 (신규 업체 기본값: 비상주)
    CreateColumn(
      'residentYn',
      '상주 여부',
      'center',
      120,
      true,
      true,
      false,
      'select',
      {
        selectOptions: ['상주', '비상주'],
        defaultValue: '비상주',
      }
    ),
    // 내용 컬럼
    CreateColumn('content', '내용', 'left', 100, true, false, false, 'text', {
      flex: 1,
      minWidth: 100,
      maxLength: 100,
    }),
    // 대표자(연락처) 컬럼
    CreateColumn(
      'ceoTel',
      '대표자(연락처)',
      'center',
      200,
      true,
      false,
      false,
      'phone',
      {
        minWidth: 150,
      }
    ),
    // 대표자성명 컬럼
    CreateColumn('ceo', '대표자성명', 'left', 100, true, false, false, 'text', {
      flex: 1,
      minWidth: 100,
      maxLength: 100,
    }),
    // 관리자(연락처) 컬럼
    CreateColumn(
      'custTel',
      '관리자(연락처)',
      'center',
      200,
      true,
      false,
      false,
      'phone',
      {
        minWidth: 150,
      }
    ),
    CreateColumn(
      'custManageRank',
      '관리자직위',
      'left',
      100,
      true,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 100,
        maxLength: 100,
      }
    ),
    // 관리자성명 컬럼
    CreateColumn(
      'custManageNm',
      '관리자성명',
      'left',
      100,
      true,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 100,
        maxLength: 100,
      }
    ),
    // 근로자수 컬럼
    CreateColumn(
      'workNo',
      '근로자수',
      'right',
      150,
      true,
      false,
      false,
      'number',
      {
        minWidth: 100,
      }
    ),
    // 비고 컬럼
    CreateColumn('remark', '비고', 'left', 200, true, false, false, 'text', {
      minWidth: 100,
      maxLength: 100,
    }),
    // 평가 버튼 컬럼
    CreateColumn('', '평가', 'center', 180, false, false, false, 'button', {
      minWidth: 180,
      buttonText: '평가하기',
      buttonCondition: (params) => {
        return !(params.data?.newYn === 'Y' || params.data?.editYn === 'Y');
      },
      buttonClickHandler: (params) => {
        props.PopupClickEvent2(params.data.partnerCd);
      },
    }),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
